import { NgModule } from '@angular/core';
import { SharedModule } from '../shared.module';
import { CurrencyMoneyComponent } from './currency-money.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { CurrencyCountryPipeModule } from '@pipes/currency-country/currency-country.module';

@NgModule({
  declarations: [CurrencyMoneyComponent],
  imports: [
    SharedModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatRadioModule,
    CurrencyCountryPipeModule,
  ],
  exports: [CurrencyMoneyComponent],
})
export class CurrencyMoneyModule {}
